import React from 'react';
import { isTrialExpired, getTrialDaysRemaining } from './TrialGate';

export default function TrialBanner({ profile, onUpgrade }) {
  if (!profile?.is_trial) return null;
  if (isTrialExpired(profile?.trial_started_at)) return null;
  if (profile?.trial_converted) return null;

  const daysRemaining = getTrialDaysRemaining(profile?.trial_started_at);
  const isLastDay = daysRemaining <= 1;

  const bannerStyle = {
    background: 'var(--accent)',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
  };

  const textStyle = {
    color: 'var(--text)',
    fontSize: '13px',
    margin: 0,
  };

  const upgradeLinkStyle = {
    background: 'transparent',
    border: 'none',
    color: 'var(--text)',
    fontSize: '13px',
    fontWeight: '600',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: 0,
  };

  if (isLastDay) {
    return (
      <div style={bannerStyle}>
        <span style={textStyle}>Last day of your free trial. Upgrade now to keep your progress.</span>
        <button
          style={upgradeLinkStyle}
          onClick={() => {
            if (onUpgrade) onUpgrade();
          }}
        >
          Upgrade Now →
        </button>
      </div>
    );
  }

  return (
    <div style={bannerStyle}>
      <span style={textStyle}>
        Free Trial — {daysRemaining} days remaining.{' '}
      </span>
      <button
        style={upgradeLinkStyle}
        onClick={() => {
          if (onUpgrade) onUpgrade();
        }}
      >
        Upgrade Now →
      </button>
    </div>
  );
}
